'use client';
export const tranText: any = {
    us: {
        title: 'Redeem EcoCredits for Rewards',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: 'OFF',
        card_price_tips: 'Minimum purchase amount',
        card_discount_code: 'Discount code',
        card_credits: 'EcoCredits',
        card_rules: 'Rules',
        card_btn: 'REDEEM NOW',
        more_text: '',
        credits_1: 'You have',
        credits_2: 'EcoCredits',
        win_item_desc: 'Are you sure you want to redeem? Cannot be undone.',
        win_item_btn: 'Confirm',
        win_a_success_title: 'Redeemed successfully!',
        win_a_success_desc: 'You have copied the code, please go to the store to use it.',
        win_a_success_btn: 'Shop Now',
        rules: {
            order_rule: 'Only one discount code per order.',
            site_rules: 'For US store only.',
            purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
            product_rules: 'For {product} only.',
            minimum_price: 'Minimum purchase amount ({price}).',
            minimum_num: 'Minimum quantity of items({num} pcs).',
            days_rules: 'Valid for {days} days from redemption.',
            days_rules2: 'Valid from {startTime} - {endTime}.',
            campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        },
    },
    jp: {
        tab1: 'アイテム',
        tab2: 'ギフトカード',
        tab3: '',
        card_off: 'OFF',
        card_discount_code: 'Discount code',
        card_credits: 'ポイント',
        card_rules: '条件',
        card_btn: '今すぐ交換',
        more_text: 'すべて表示',
        credits_1: 'ポイント',
        credits_2: 'があります',
        win_item_desc: '本当に交換をしますか？一度交換した特典を取り消すことはできません。',
        win_item_btn: '確 認',
        win_a_success_title: 'Redeemed successfully!',
        win_a_success_desc: 'You have copied the code, please go to the store to use it.',
        win_a_success_btn: 'Shop Now',
        rules: {
            order_rule: '*割引コードは、1回の注文につき1つしか利用することができません。',
            site_rules: '*EcoFlow Japan公式サイトのストアでのみ適用します。',
            purchas_rule: '*クーポンの値引き額が商品金額を上回っていた場合、差額分は返金されません。',
            product_rules: '*{product}のみ対象です。',
            minimum_price: '*最低購入金額 ({price})。',
            minimum_num: '*最低購入個数以上 ({num} 個) の購入時に使用可能です。',
            days_rules: '*交換後、有効期限は{days}日間です。',
            days_rules2: '*交換後の有効期間は{startTime} - {endTime}です。',
            campaign_time_limit_text: '交換有効期間：{startTime} - {endTime}.',
        },
    },
    eu: {
        title: 'Redeem EcoCredits for Rewards',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: 'OFF',
        card_price_tips: 'Minimum purchase amount',
        card_discount_code: 'Discount code',
        card_credits: 'EcoCredits',
        card_rules: 'Rules',
        card_btn: 'REDEEM NOW',
        more_text: '',
        credits_1: 'You have',
        credits_2: 'EcoCredits',
        win_item_desc: 'Are you sure you want to redeem? Cannot be undone.',
        win_item_btn: 'Confirm',
        win_a_success_title: 'Redeemed successfully!',
        win_a_success_desc: 'You have copied the code, please go to the store to use it.',
        win_a_success_btn: 'Shop Now',
        rules: {
            order_rule: 'Only one discount code per order.',
            site_rules: 'For EU store only.',
            purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
            product_rules: 'For {product} only.',
            minimum_price: 'Minimum purchase amount ({price}).',
            minimum_num: 'Minimum quantity of items({num} pcs).',
            days_rules: 'Valid for {days} days from redemption.',
            days_rules2: 'Valid from {startTime} - {endTime}.',
            campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        },
    },
    uk: {
        title: 'Redeem EcoCredits for Rewards',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: 'OFF',
        card_price_tips: 'Minimum purchase amount',
        card_discount_code: 'Discount code',
        card_credits: 'EcoCredits',
        card_rules: 'Rules',
        card_btn: 'REDEEM NOW',
        more_text: 'View all',
        credits_1: 'You have',
        credits_2: 'EcoCredits',
        win_item_desc: 'Are you sure you want to redeem? Cannot be undone.',
        win_item_btn: 'Confirm',
        win_a_success_title: 'Redeemed successfully!',
        win_a_success_desc: 'You have copied the code, please go to the store to use it.',
        win_a_success_btn: 'Shop Now',
        rules: {
            order_rule: 'Only one discount code per order.',
            site_rules: 'For UK store only.',
            purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
            product_rules: 'For {product} only.',
            minimum_price: 'Minimum purchase amount ({price}).',
            minimum_num: 'Minimum quantity of items({num} pcs).',
            days_rules: 'Valid for {days} days from redemption.',
            days_rules2: 'Valid from {startTime} - {endTime}.',
            campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        },
    },
    de: {
        title: 'EcoCredits für Prämien einlösen',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: 'RABATT',
        card_price_tips: 'Mindestausgaben',
        card_discount_code: 'Coupon',
        card_credits: 'EcoCredits',
        card_rules: 'Regeln',
        card_btn: 'JETZT EINLÖSEN',
        more_text: '',
        credits_1: 'Sie haben ',
        credits_2: ' EcoCredits',
        win_item_desc: 'Möchten Sie wirklich einlösen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
        win_item_btn: 'Bestätigen',
        win_a_success_title: 'Das Einlösen war erfolgreich!',
        win_a_success_desc: 'Sie haben den Code kopiert. Sie können jetzt zum Shop gehen und ihn benutzen.',
        win_a_success_btn: 'Jetzt kaufen',
        rules: {
            order_rule: 'Für jede Bestellung kann nur ein Gutscheincode verwendet werden.',
            site_rules: 'Nur für DE-Shop.',
            purchas_rule: 'Wenn Sie einen Artikel für weniger als den/die Gutschein(e) kaufen, verfällt der Differenzbetrag.',
            product_rules: 'Nur für {product}',
            minimum_price: 'Mindestausgaben ({price}).',
            minimum_num: 'Mindestmenge an Artikeln ({num} Stück).',
            days_rules: 'Gültig für {days} Tage ab Einlösung',
            days_rules2: 'Gültig ab {startTime} - {endTime}.',
            campaign_time_limit_text: 'Gültiger Einlösungszeitraum:  {startTime} - {endTime}.',
        },
    },
    fr: {
        title: 'Échangez vos EcoCredits contre des récompenses',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: 'OFF',
        card_price_tips: `Montant minimum d'achat`,
        card_discount_code: 'Code de réduction',
        card_credits: 'EcoCredits',
        card_rules: 'Règles',
        card_btn: 'ÉCHANGER',
        more_text: '',
        credits_1: 'Vous avez',
        credits_2: 'EcoCredits',
        win_item_desc: `Voulez-vous vraiment procéder à l'échange ? Vous ne pouvez pas annuler cette action.`,
        win_item_btn: 'Confirmer',
        win_a_success_title: 'Échangées avec succès !',
        win_a_success_desc: `Vous avez copié le code, veuillez vous rendre en boutique pour l'utiliser.`,
        win_a_success_btn: 'Acheter maintenant',
        rules: {
            order_rule: 'Un seul code promo par commande.',
            site_rules: 'Réservé aux clients de la boutique française.',
            purchas_rule: "Si le prix de l'article est inférieur à la valeur du/des code(s) promo, la différence sera perdue.",
            product_rules: 'Pour {product} seulement',
            minimum_price: "Montant minimum d'achat ({price}).",
            minimum_num: "Quantité minimum d'articles ({num} articles).",
            days_rules: "Valable pendant {days} jours à partir de la date d'échange",
            days_rules2: 'Valable à partir de {startTime} - {endTime}.',
            campaign_time_limit_text: 'Période de remboursement valide: {startTime} - {endTime}.',
        },
    },
    it: {
        title: 'Riscatta gli EcoCredits per ricevere premi',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: 'OFF',
        card_price_tips: 'Importo minimo di acquisto',
        card_discount_code: 'Codice di sconto',
        card_credits: 'EcoCredits',
        card_rules: 'Regole',
        card_btn: 'RISCATTA ORA',
        more_text: '',
        credits_1: 'Hai ',
        credits_2: 'EcoCredits',
        win_item_desc: 'Riscattare i EcoCredits? Questa azione non può essere annullata.',
        win_item_btn: 'Conferma',
        win_a_success_title: 'Riscattato correttamente!',
        win_a_success_desc: 'Hai copiato il codice, vai nel negozio per utilizzarlo.',
        win_a_success_btn: 'Acquista ora',
        rules: {
            order_rule: "Un solo codice sconto per un'ordine.",
            site_rules: 'Solo per il negozio italiana.',
            purchas_rule: "Se il costo dell'articolo è inferiore dei coupon, la differenza andrà persa.",
            product_rules: 'Solo per {product}',
            minimum_price: 'Importo minimo di acquisto ({price}).',
            minimum_num: 'Quantità minima di articoli ({num} pezzi).',
            days_rules: 'Valido per {days} giorni dal riscatto',
            days_rules2: 'Valido dal {startTime} - {endTime}.',
            campaign_time_limit_text: 'Periodo di riscatto valido: {startTime} - {endTime}.',
        },
    },
    es: {
        title: 'Canjea EcoCredits por recompensas',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: 'DESACTIVAR',
        card_price_tips: 'Cantidad mínima de artículos',
        card_discount_code: 'Código de descuento',
        card_credits: 'EcoCredits',
        card_rules: 'Reglas',
        card_btn: 'CANJEAR AHORA',
        more_text: '',
        credits_1: 'Tienes',
        credits_2: 'EcoCredits',
        win_item_desc: '¿Seguro que quieres canjear tus EcoCredits? Esta acción no se puede anular.',
        win_item_btn: 'Confirmar',
        win_a_success_title: '¡Canjeados correctamente!',
        win_a_success_desc: 'Has copiado el código; ve a la tienda para usarlo.',
        win_a_success_btn: 'Comprar Ahora',
        rules: {
            order_rule: 'Solo un código promocional por pedido.',
            site_rules: 'Solo para tienda de España.',
            purchas_rule: 'Al comprar un artículo por un precio inferior al del cupón, se perderá la diferencia.',
            product_rules: 'Solo para {product}',
            minimum_price: 'Monto mínimo de compra ({price}).',
            minimum_num: 'Cantidad mínima de artículos ({num} piezas).',
            days_rules: ' Válido durante {days} días desde el canje.',
            days_rules2: 'Válido desde {startTime} - {endTime}.',
            campaign_time_limit_text: 'Periodo de canje válido: {startTime} - {endTime}.',
        },
    },
    kr: {
        title: '에코 포인트 전환하기',
        tab1: '',
        tab2: '',
        tab3: '',
        card_off: '할인',
        card_price_tips: '최소 구매 금액',
        card_discount_code: '할인 쿠폰',
        card_credits: '포인트',
        card_rules: '포인트 사용 규칙',
        card_btn: '바로 사용하기',
        more_text: '',
        credits_1: '에코 포인트: ',
        credits_2: ' P',
        win_item_desc: '포인트를 사용하시겠습니까? \n사용하면 취소할 수 없습니다.',
        win_item_btn: '확인',
        win_a_success_title: '성공적으로 사용했습니다!',
        win_a_success_desc: '코드를 복사​했습니다. 코드를 사용하려면 스토어로 이동​하세요.',
        win_a_success_btn: '바로 구매',
        rules: {
            order_rule: '할인코드의 중복적용은 불가능합니다.',
            site_rules: '에코플로우 코리아 공식 홈페이지에서만 적용 가능.',
            purchas_rule: '쿠폰 금액보다 적은 금액으로 상품을 구매하는 경우,\n 차액이 회수됩니다.',
            product_rules: '{product} 상품에만 해당',
            minimum_price: '최소 구매 금액 ({price}).',
            minimum_num: '최소 품목 수량({num} 개).',
            days_rules: '리워드 사용일로부터 {days}일 동안 유효.',
            days_rules2: '{startTime} - {endTime}.부터 유효.',
            campaign_time_limit_text: '포인트 전환의 유효 기간: {startTime} - {endTime}.',
        },
    },
};
